export default "__VITE_ASSET__BxLbr$rZ__"